"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { LeadForm } from "@/components/ui/lead-form";

export function AboutCTA() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <div className="flex justify-center">
        <Button
          onClick={() => setIsFormOpen(true)}
          className="bg-foreground text-background hover:bg-foreground/70 text-lg px-8 py-4 h-auto"
        >
          Join Waitlist
        </Button>
      </div>

      <LeadForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        title="Get Started with PhotoZoot"
        buttonText="Submit & Join Waitlist"
      />
    </>
  );
}
